<app-card-medium title="{{ 'Users' | translate }}" redirectRoute="/users/create"
  redirectLabel="{{ 'Create a user' | translate }}" [hasAction]="true" exportLabel="{{ 'Export Login Log' | translate }}">
  <div class="content scrollable">
    <app-simple-search [cyId]="'user-search'" [data]="_users" [keys]="['name', 'email', 'id']" (res)="users = $event"></app-simple-search>
    <div class="mt-2" *ngFor="let user of users; trackById">
      <app-card-user [redirectUrl]="'edit/' + user.id" [data]="user"></app-card-user>
    </div>
  </div>
</app-card-medium>